import type { Course } from '@gpa-scales/shared-types';
import type { StateCreator } from 'zustand';
import { generateId } from '@gpa-scales/shared-logic/utils/id';
import type { AppStore } from './useAppStore';

export interface CourseSlice {
  courses: Course[];
  addCourse: (course: Omit<Course, 'id'>) => void;
  updateCourse: (id: string, updates: Partial<Course>) => void;
  deleteCourse: (id: string) => void;
  clearAllCourses: () => void;
  importCourses: (courses: Course[]) => void;
  loadDemoCourses: (courses: Course[]) => void;
  /** Reset the store to its empty/default state (clears courses + result). */
  clearDemoData: () => void;
}

export const createCourseSlice: StateCreator<AppStore, [], [], CourseSlice> = (set) => ({
  courses: [],
  addCourse: (courseData) =>
    set((state) => ({
      courses: [...state.courses, { ...courseData, id: generateId() } as Course],
    })),
  updateCourse: (id, updates) =>
    set((state) => ({
      courses: state.courses.map((c) => (c.id === id ? { ...c, ...updates } : c)),
    })),
  deleteCourse: (id) =>
    set((state) => ({
      courses: state.courses.filter((c) => c.id !== id),
    })),
  clearAllCourses: () => set({ courses: [] }),
  importCourses: (courses) => set({ courses }),
  loadDemoCourses: (courses) => set({ courses }),
  clearDemoData: () => set({ courses: [], result: null }),
});
